import { checkApi } from 'components/Authentication/AxiosInstance';
// from .appmodules.predictors import prediction_urls --- Line for reference of where urls are.

const predictions_url = '/predictors/predict/'
const states_url = '/predictors/states/'
export const fetchPredictions = async (params) => {
  const response = await checkApi(predictions_url, { params });
  return response.data;
};

export const fetchStates = async () => {
  const response = await checkApi(states_url);
  return response.data;
};